/* eslint-disable import/prefer-default-export */
import Constants from 'constants.js';

export function addGroup(questionGroup) {
  return { type: Constants.QUESTIONS_ADD, questionGroup };
}
